<div *ngIf="isActive" style="top: 0; left: 0" class="absolute w100 h100 welcom-animation-screen">
    <div class="absolute w100 h100 flex items-center justify-center flex-column dark-overlay">
        <img class="m-b35 welcome-animation-logo" src="../../../assets/images/Amwell-Gold.svg" />
        <h2 class="white-text">Welcome!</h2>
    </div>
</div>
